import { render, staticRenderFns } from "./BtnEliminar.vue?vue&type=template&id=6a28aa5e&scoped=true"
import script from "./BtnEliminar.vue?vue&type=script&lang=js"
export * from "./BtnEliminar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a28aa5e",
  null
  
)

export default component.exports